import { useEffect, useRef, useState } from 'react';
import { formatDate } from '../../../../lib/date';
import request from '../../../../lib/request';
import Item from './item';
import Detail from './detail';

const ChallengeList = ({ status }) => {
  const detailRef = useRef(null);

  const [workoutChallenges, setWorkoutChallenges] = useState([]);
  const [habitChallenges, setHabitChallenges] = useState([]);
  const [selectedChallenge, setSelectedChallenge] = useState({});
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);

  useEffect(() => {
    getChallenges();
  }, [status]);

  const getChallenges = async () => {
    try {
      const { result } = await request.get(
        `/user/challenges?status=${status}&localDate=${formatDate(new Date())}`
      );
      if (Array.isArray(result) && result.length > 0) {
        setWorkoutChallenges(
          result.filter(
            (res) => res.category === 'WORKOUT' || res.category === 'CUSTOM'
          )
        );
        setHabitChallenges(result.filter((res) => res.category === 'HABIT'));
      } else {
        setWorkoutChallenges([]);
        setHabitChallenges([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSelectChallenge = (challenge) => () => {
    setSelectedChallenge(challenge);
    openDetailDialog();
  };

  const openDetailDialog = () => {
    if (detailRef.current) {
      detailRef.current.showModal();
      setIsDetailDialogOpen(true);
    }
  };

  const closeDetailDialog = () => {
    if (detailRef.current) {
      detailRef.current.close();
      setIsDetailDialogOpen(false);
    }
  };

  return (
    <div>
      <div className='space-y-4'>
        {workoutChallenges.length > 0 && (
          <div>
            <h2 className='font-bold mb-1 text-white'>Workout</h2>
            <div className='space-y-2'>
              {workoutChallenges.map((challenge) => (
                <Item
                  key={challenge.id}
                  item={challenge}
                  handleSelectChallenge={handleSelectChallenge(challenge)}
                  status={status}
                />
              ))}
            </div>
          </div>
        )}
        {habitChallenges.length > 0 && (
          <div>
            <h2 className='font-bold mb-1 text-white'>Habit</h2>
            <div className='space-y-2'>
              {habitChallenges.map((challenge) => (
                <Item
                  key={challenge.id}
                  item={challenge}
                  handleSelectChallenge={handleSelectChallenge(challenge)}
                  status={status}
                />
              ))}
            </div>
          </div>
        )}
        {workoutChallenges.length === 0 && habitChallenges.length === 0 && (
          <div className='text-center text-sm opacity-40 text-white'>
            No challenges found
          </div>
        )}
      </div>
      <Detail
        dialogRef={detailRef}
        closeDialog={closeDetailDialog}
        challenge={selectedChallenge}
        refresh={getChallenges}
        isDetailDialogOpen={isDetailDialogOpen}
        status={status}
      />
    </div>
  );
};

export default ChallengeList;
